import React, { Component } from "react";

import { withStyles } from "@mui/styles";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Styles } from "src/styles/material-styles";
import * as articleActions from 'src/redux/actions/articles';
import PropTypes from 'prop-types';
import { AbilityContext } from "src/config/ability-context";
import Api from "src/services/api";
import { Container, Grid } from "@mui/material";
import Header from "src/components/header-external";
import { PapiroConsole } from "src/utils/papiroConsole";
import Footer from "src/components/footer-external";
import * as FileService from 'src/services/attachment.service';
import Modal from "src/components/modal-external/modal-principal";
import CustomizedSnackbars from "src/components/material-snackbars";
import LogoMarca from 'src/images/new-logo2-cmtech.png'
import { browserHistory } from "src/helpers/history";
import { getTagsAndEnableTagsOnArticlesExternal } from '../../services/tags.service'
import CalledServicesSettingsExternalFormList from "../client-portal-external/components/called-services-settings-external-form-list";

import CommonSearchExternal from "src/components/client-portal/common-search-external";
import ArticleMainContent from "src/components/article-external-components/article-main-content";
import ArticleMainContentSkeleton from "src/components/article-external-components/article-main-content-skeleton";
import CommonExternalDynamicArticles from "src/components/client-portal/common-external-dynamic-articles";
import SkeletonCommonExternalDynamicArticles from "src/components/client-portal/skeleton-common-external-dynamic-articles";
import CommonBackButtonExternal from "src/components/client-portal/common-back-button-external";
class ArticleExternal extends Component {
    constructor(props) {
        super(props)

        this.initialState = {
            id: 0,
            hirerid: 0,
            articlesectionid: 0,
            title: '',
            content: '',
            subtitle: '',
            articlesattachments: [],
        }

        this.state = {
            article: this.initialState,
            clientportal: {},
            articlesections: [],
            articleSectionsExternalList: [],
            articleSectionsExternalBreadCrumb: [],
            loading: false,
            loadingInternal: false,
            loadingFeedback: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            searchvalue: '',
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            logoimagesrc: '',
            tags: [],
            feedbackState: 'checking',
            feedbackReason: '',
            feedbackOptions: [],
            descriptionText: '',
            showDescriptionModal: false,
            errorMessage: '',
        }

        this.pageInitialize = this.pageInitialize.bind(this)
        this.dataInitialize = this.dataInitialize.bind(this)
        this.goToScrollTop = this.goToScrollTop.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeCreateCalledDialog = this.closeCreateCalledDialog.bind(this)
        this.getFile = this.getFile.bind(this)
        this.downloadFile = this.downloadFile.bind(this)
        this.closeNotification = this.closeNotification.bind(this)
        this.searchArticle = this.searchArticle.bind(this)
        this.handleBreadCrumbClick = this.handleBreadCrumbClick.bind(this)
        this.handleClickOpenSectionBreadCrumbs = this.handleClickOpenSectionBreadCrumbs.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.getArticleSectionsExternalList = this.getArticleSectionsExternalList.bind(this)
        this.formattedArticleSectionsExternalBreadCrumb = this.formattedArticleSectionsExternalBreadCrumb.bind(this)
        this.handleDescriptionSubmit = this.handleDescriptionSubmit.bind(this);
        this.openDescriptionModal = this.openDescriptionModal.bind(this);
        this.handleChangeDescriptionText = this.handleChangeDescriptionText.bind(this);
        this.handleGoToNewArticle = this.handleGoToNewArticle.bind(this);
        this.handleChangeURL = this.handleChangeURL.bind(this);

        this.topRef = React.createRef();
    }

    async componentWillReceiveProps() {
        await this.componentDidMount()
    }

    async componentDidMount() {
        this.setState({ loading: true })

        await this.getHirerId()
        await this.getClientPortal()
        await this.fetchFeedbackOptions()

        var { id } = this.props.match.params
        await this.dataInitialize(id)

        this.pageInitialize();
        this.setState({ loading: false })
    }

    pageInitialize = () => {
        document.title = this.state.appName;

        this.goToScrollTop();
    }

    dataInitialize = async (id) => {
        await this.getArticle(id)

        if (!!this.state.article?.id && this.state.article?.id > 0) {
            await this.getFeedbackStatus(this.state.article.id);
            await this.getArticleSection()
            await this.getArticleSectionsExternalList();

            await this.getTagsAndEnableTagsOnArticles(this.state.article.id);
        }
    }

    goToScrollTop = () => {
        if (this.topRef.current) {
            this.topRef.current.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    fetchFeedbackOptions = async () => {
        try {
            const result = await Api.get(`feedback-article/get-all-external/${this.state.hirerid}`);
            if (result.data.success) {
                let options = result.data.data;

                const textoOutroMotivo = this.props.intl.formatMessage({ id: "article.feedback.other_reason" }) || "Outro motivo / Descrição";

                const staticOption = {
                    id: -1,
                    description: `<span style="font-size: 16px; font-weight: bold;">${textoOutroMotivo}</span>`
                };

                options.push(staticOption);

                this.setState({ feedbackOptions: options });
            } else {
                throw new Error("Não foi possível carregar as opções de feedback.");

            }
        } catch (err) {
            PapiroConsole.log("Erro ao buscar opções de feedback:", err);
        }
    }

    sendFeedback = async (feedbackPayload) => {
        const { article, hirerid } = this.state;
        const { intl } = this.props;

        const formData = new FormData();
        formData.append('ArticleId', article.id);
        formData.append('HirerId', hirerid);

        formData.append('WasHelpful', feedbackPayload.WasHelpful);

        formData.append('Description', feedbackPayload.Description || '');

        if (feedbackPayload.ReasonId && feedbackPayload.ReasonId !== "") {
            formData.append('ReasonId', feedbackPayload.ReasonId);
        }
        this.setState({ loadingFeedback: true, openNotification: false });

        try {
            const result = await Api.post('feedback-article/create-external', formData);

            if (result.data && result.data.success) {
                this.setState({
                    // STATE 'thankyou' EXIBIDO APENAS PARA USUÁRIOS QUE ENVIARAM FEEDBACK, POIS O SISTEMA PERMITE APENAS 1 VOTO POR USUÁRIO
                    feedbackState: 'thankyou',

                    // resetar campos relacionados ao feedback para o estado inicial, caso o usuário queira enviar outro feedback para um artigo diferente
                    showDescriptionModal: false,
                    feedbackReason: '',
                    descriptionText: '',

                    // loadingFeedback DESATIVADO APENAS APÓS RECEBER RESPOSTA DO SERVIDOR, PARA EVITAR QUE O USUÁRIO ENVIE MAIS DE UM FEEDBACK ENQUANTO O PRIMEIRO ESTIVER SENDO PROCESSADO
                    loadingFeedback: false,

                    // notificação de sucesso exibida apenas após receber resposta do servidor, para evitar confusão do usuário caso ele envie mais de um feedback rapidamente
                    openNotification: true,
                    notificationVariant: 'success',
                    notificationMessage: intl.formatMessage({ id: "article.feedback.thankyouevaluation" })
                });
            } else {
                throw new Error(result.data.reasonPhrase || 'Erro ao enviar feedback.');
            }
        } catch (err) {
            let errorMessage = intl.formatMessage({ id: "process.error" });

            if (err.response && err.response.status === 400) {
                errorMessage = err.response.data.reasonPhrase || intl.formatMessage({ id: "article.feedback.alreadysent" });
                this.setState({ feedbackState: 'thankyou' });
            } else {
                errorMessage = err.message || intl.formatMessage({ id: "process.error" });
            }

            this.setState({
                loadingFeedback: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: errorMessage
            });
        }
    }

    handleInitialFeedback = (wasHelpful) => {
        if (wasHelpful) {

            this.sendFeedback({
                WasHelpful: true,
                SelectedOption: 'sim',
                Description: '',
            });
        } else {

            this.setState({ feedbackState: 'detailed' });
        }
    }

    handleFeedbackSubmit = (e) => {
        e.preventDefault();
        const { feedbackReason, descriptionText } = this.state;
        const { intl } = this.props;

        if (!feedbackReason) {
            this.setState({
                openNotification: true,
                notificationVariant: 'warning',
                notificationMessage: intl.formatMessage({ id: "article.feedback.pleaseselectreason" })
            });
            return;
        }

        const selectedId = parseInt(feedbackReason);


        if (selectedId === -1) {

            if (!descriptionText || !descriptionText.trim()) {
                this.setState({
                    openNotification: true,
                    notificationVariant: 'warning',
                    notificationMessage: intl.formatMessage({ id: "article.feedback.descriptionrequired" })
                });
                return;
            }


            this.sendFeedback({
                WasHelpful: false,
                ReasonId: null,
                Description: descriptionText
            });

        } else {

            this.sendFeedback({
                WasHelpful: false,
                ReasonId: selectedId,
                Description: ''
            });
        }
    }

    handleDescriptionSubmit = (descriptionText) => {
        if (!descriptionText || !descriptionText.trim()) {
            this.setState({
                openNotification: true,
                notificationVariant: 'warning',
                notificationMessage: this.props.intl.formatMessage({ id: "article.feedback.descriptionrequired" })
            });
            return;
        }

        const { feedbackReason } = this.state;
        const currentId = parseInt(feedbackReason);


        const finalReasonId = currentId === -1 ? null : currentId;


        this.sendFeedback({
            WasHelpful: false,
            ReasonId: finalReasonId,
            Description: descriptionText
        });


        this.setState({ showDescriptionModal: false, descriptionText: '' });
    }

    openDescriptionModal = () => {
        this.setState({ showDescriptionModal: true });
    }

    handleChangeDescriptionText = (e) => {
        this.setState({ descriptionText: e.target.value });
    }

    resetFeedbackState = () => {
        this.setState({
            feedbackState: 'initial',
            feedbackReason: '',
            showDescriptionModal: false
        });
    }

    getHirerId = async () => {
        const intl = this.props.intl

        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerid: result.data.data.hirerid })
                        else {
                            var l = this.props.match.params.lang;
                            document.location.href = `/${l}/unavailable`
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err)
            })
    }

    async getFeedbackStatus(articleId) {
        try {
            const result = await Api.get(`feedback-article/check-vote/${articleId}`);

            if (result.data && result.data.success) {
                const responseData = result.data.data;

                if (responseData) {
                    const jaVotou = responseData.hasVoted === true || responseData.hasvoted === true;

                    if (jaVotou) {
                        this.setState({ feedbackState: 'alreadyVoted' });
                    }
                }
            }
        } catch (err) {
            console.error("Erro ao verificar status do voto", err);
        }
    }

    async getArticle(id) {
        const { intl } = this.props

        if (!!id && !!this.state.article && this.state.article?.id == id) return;

        await Api.get(`articles/external/${id}`)
            .then(async result => {
                if (result.data && result.data.success) {
                    const articleData = result.data.data;

                    const userHasVoted =
                        articleData.hasAlreadyVoted === true ||
                        articleData.hasalreadyvoted === true ||
                        String(articleData.hasalreadyvoted) === "true";

                    await this.setState({
                        article: articleData,
                        feedbackState: userHasVoted ? 'alreadyVoted' : 'initial'
                    })
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                PapiroConsole.log("err: ", err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
            })
    }

    async getArticleSection() {
        const { intl } = this.props

        const sectionId = this.state.article && this.state.article.sectionid ? this.state.article.sectionid : null;

        await Api.get(`articles-section/parents/${sectionId}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        articlesections: result.data.data
                    })
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getArticleSectionsExternalList() {
        const { intl } = this.props;

        const { hirerid, articlesections } = this.state;

        if (!articlesections || articlesections.length <= 0) return;

        let articlesectionidlist = [];

        if (articlesections && articlesections.length > 0) {
            articlesectionidlist = articlesections.map((item) => item.id);
        }

        if (articlesectionidlist.length <= 0) return;

        const _articlesectionidlist = articlesectionidlist.join(',');

        let url = `articles/paginatebyarticlesection/breadcrumbs`;
        url += `?hirerid=${hirerid}`;
        url += `&articlesectionidlist=${_articlesectionidlist}`;

        await Api.get(url)
            .then(result => {
                if (result.data && result.data.success) {
                    let list = result.data.data;

                    this.setState({
                        articleSectionsExternalBreadCrumb: this.formattedArticleSectionsExternalBreadCrumb(list)
                    })

                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })

                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    formattedArticleSectionsExternalBreadCrumb(articleSectionsExternalList) {
        const { articlesections, article } = this.state;

        const currentArticleId = article && article.id ? article.id : null;

        let data = [];

        if (articlesections && articlesections.length <= 0) return data;

        articlesections.forEach((section) => {
            let sectionData = {
                ...section,
                open: false,
                mapName: section.name,
                mapArticles: [],
            };

            data.push(sectionData);
        });

        if (articleSectionsExternalList && articleSectionsExternalList.length > 0) {
            articleSectionsExternalList.forEach(article => {
                const section = data.find(s => s.id === article.sectionid);

                const isActiveSection = article.id === parseInt(currentArticleId);

                if (section) {
                    const mapName = `${section.name}/${article.title}`;

                    const _article = {
                        ...article,
                        mapName
                    }

                    section.open = isActiveSection ? true : section.open;
                    section.mapArticles.push(_article);
                }
            });
        }

        const _data = data.filter(section => section && section?.mapArticles?.length > 0);

        return _data;
    }

    async getClientPortal() {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        clientportal: result.data.data
                    })
                    if (result.data.data.logoimage) {
                        this.getFile(result.data.data.logoimage)
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getFile(image)
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    getFile = async (image) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ logoimagesrc: ImageData.data })
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value
        })
    }

    downloadFile = async (attachment) => {
        const intl = this.props.intl
        let url = await FileService.getFileDownloadLink(attachment.attachmentid);
        if (url && url.data && url.data.data && url.data.success) {
            window.open(`${url.data.data}`, "_blank")
        } else {
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "file.not.found" }),
            })
        }
    }

    useStyles = () => {
        return withStyles({
            ImageList: {
                width: "100%",
                height: 100,
            },
        })
    }

    searchArticle = (searchText) => {
        this.props.addCurrentSearch(searchText, 'text')
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }

    handleBreadCrumbClick = (sectionId) => {
        this.props.history.push(`/${this.props.match.params.lang}/news-section/${sectionId}`)
    }

    handleChangeURL = (articlesectionid) => {
        const url = new URL(window.location.href);
        url.pathname = url.pathname.replace(/\/\d+$/, `/${articlesectionid}`);
        window.history.pushState({ path: url.href }, '', url.href);
    }

    handleGoToNewArticle = (articlesectionid) => {
        const nextId = String(articlesectionid);

        if (!nextId || nextId === "") return;

        this.setState({ loadingInternal: true }, async () => {
            await this.dataInitialize(nextId);

            this.handleChangeURL(nextId);

            this.setState({ loadingInternal: false });
        });
    }

    handleBack = () => {
        const { history, match } = this.props;
        if (history.length > 1) {
            browserHistory.goBack();
        } else {
            history.push(`/${match.params.lang}/client-portal-external`);
        }
    }

    async getTagsAndEnableTagsOnArticles(id) {

        let result = await getTagsAndEnableTagsOnArticlesExternal(id, this.state.hirerid)
        if (result && result.success) {
            this.setState({
                enableTagsOnArticles: result.data.enabletagsonarticles,
                tags: result.data.tags
            })
        }
        else {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    result.response && result.response.data && result.response.data.errors
                        ? result.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
            });

            Api.kickoff(result);
        }
    }

    handleClickOpenSectionBreadCrumbs(id) {
        const { articleSectionsExternalBreadCrumb } = this.state;

        let helpNewArticle = [...articleSectionsExternalBreadCrumb];

        const getArticle = helpNewArticle.findIndex(a => a.id === id);

        helpNewArticle[getArticle].open = !helpNewArticle[getArticle].open;

        this.setState({
            articleSectionsExternalBreadCrumb: helpNewArticle
        });
    };

    render() {

        const { classes, intl } = this.props

        const { clientportal, hirerid, logoimagesrc, loading, loadingInternal } = this.state

        const classes2 = this.useStyles()

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root}>
                <main className={classes.contentExternal} ref={this.topRef}>

                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, padding: 0 }}>
                        <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container spacing={4}>
                                <Header
                                    intl={this.props.intl}
                                    clientportal={clientportal}
                                    calledservicesettings={clientportal.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                    loading={loading}
                                />

                                <CommonSearchExternal
                                    state={this.state}
                                    clientportal={clientportal}
                                    loading={loading}
                                    nameTextField={"searchvalue"}
                                    handleChange={this.handleChange}
                                    searchArticle={this.searchArticle}
                                    simple
                                />

                                <Grid item sm={12} container ml={"21vw"} mr={"15vw"} maxWidth={'60vw'} >
                                    <CommonBackButtonExternal
                                        clientportal={clientportal}
                                        loading={loading}
                                        handleBack={this.handleBack}
                                    />
                                </Grid>

                                <ArticleMainContentSkeleton
                                    showSections={true}
                                    showFeedback={true}
                                    sectionsCount={2}
                                    articlesPerSection={2}
                                    contentParagraphs={3}
                                    animation="wave"
                                    loading={loading || loadingInternal}
                                    mainContainerProps={{
                                        ml: "22vw",
                                        mr: "12vw",
                                        mt: 3,
                                        mb: 6,
                                        maxWidth: '100vw'
                                    }}

                                />

                                {(!loading && !loadingInternal) && (
                                    <ArticleMainContent
                                        state={this.state}
                                        classes={classes}
                                        classes2={classes2}
                                        clientportal={clientportal}

                                        handleBreadCrumbClick={this.handleBreadCrumbClick}
                                        handleClickOpenSectionBreadCrumbs={this.handleClickOpenSectionBreadCrumbs}
                                        handleGoToNewArticle={this.handleGoToNewArticle}
                                        downloadFile={this.downloadFile}
                                        handleTagClick={this.searchArticle}

                                        handleInitialFeedback={this.handleInitialFeedback}
                                        resetFeedbackState={this.resetFeedbackState}
                                        handleFeedbackSubmit={this.handleFeedbackSubmit}

                                        handleChange={this.handleChange}

                                        goToScrollTop={this.goToScrollTop}
                                        topRef={this.topRef}
                                    />
                                )}

                                <Grid container marginX="20vw" maxWidth={'60vw'} spacing={5} mt={1}>
                                    <SkeletonCommonExternalDynamicArticles loading={loading} />

                                    {!loading &&
                                        <CommonExternalDynamicArticles
                                            clientportal={clientportal}
                                            hirerid={hirerid}
                                            setNotification={this.setNotification}
                                        />
                                    }
                                </Grid>

                            </Grid>

                            <Footer
                                intl={intl}
                                clientportal={clientportal}
                                loading={loading}
                                setLoading={loading => this.setState({ loading: loading })}
                            />
                        </Grid>

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        <Modal
                            intl={intl}
                            title={<strong style={{ color: this.state.clientportal.defaulttextcolor }}>{this.state.clientportal.createcalledpagetitle || intl.formatMessage({ id: "choose.form" })}</strong>}
                            open={this.state.createCalledDialogOpen}
                            onClose={this.closeCreateCalledDialog}
                            contentPadding={false}
                            maxWidth="md"
                            children={
                                <CalledServicesSettingsExternalFormList
                                    calledServiceSettingsList={this.state.calledServiceSettingsList}
                                    clientportal={clientportal}
                                />
                            }
                        />
                    </Container>
                </main>
            </div >
        )
    }
}

ArticleExternal.propTypes = (state) => ({
    classes: PropTypes.object.isRequired,
})

const mapStateToProps = (state) => ({
    classes: PropTypes.object.isRequired,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(articleActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ArticleExternal)));
ArticleExternal.contextType = AbilityContext;